import { Component, OnInit, Inject } from '@angular/core';
import { NbAuthSocialLink, NB_AUTH_OPTIONS, getDeepFromObject } from '@nebular/auth';
import { AuthService } from '../../auth/auth-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent {

  errors: string[] = [];
  messages: string[] = [];

  showMessages: any = {};
  submitted: boolean = false;

  public userDetails: firebase.User = JSON.parse(localStorage.getItem('userAuth'));

  constructor(protected auth: AuthService, @Inject(NB_AUTH_OPTIONS) protected config = {}, protected router: Router) {
  }

  sendVerificationEmail() {
    this.errors = this.messages = [];
    this.submitted = true;
    this.auth.sendEmailVerification().then((res) => {
      this.submitted = false;
      this.messages = ['Mensaje enviado a ' + this.auth.userDetails.email + '. Revise su bandeja. Si no lo encuentra, verifique la carpeta de correo no deseado.'];
    }).catch((err) => {
      this.submitted = false;
      this.errors = [err];
    });

  }
}
